(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('MusicalArrangement', MusicalArrangement);

    MusicalArrangement.$inject = ['$resource'];

    function MusicalArrangement ($resource) {
        var resourceUrl =  'api/musical-arrangements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
